import { defineStore } from 'pinia';
import { reactive, ref, markRaw } from 'vue';

export const useApiIntegrationComponentStore = defineStore('apiIntegrationComponent', () => {
    const fields = reactive([]);
    const columns = ref([
        { title: 'Наименование сервиса', key: 'name', sortable: false, priority: 100 },
        { title: 'Токен', key: 'token', width: '525px', sortable: false, priority: 75 },
        { title: 'Статус', key: 'is_active', width: '168px', priority: 50 },
        { title: 'Дата создания', key: 'created_at', width: '144px', sortable: false, priority: 25 },
        { title: '', key: 'actions', sortable: false, width: '155px', priority: 0 },
    ]);

    function registerField(field) {
        fields.push(markRaw(field));
    }

    function getFields() {
        return fields;
    }

    function addColumn(column) {
        columns.value.push(column);
    }

    function getColumnsHeaders() {
        return columns.value.sort(
            (a, b) => b.priority - a.priority
        );
    }

    return {
        registerField,
        getFields,
        addColumn,
        getColumnsHeaders,
    };
});
